import axios from 'axios'

import { ApiBase } from '@/api/api'
import type { ReportQueryProps } from '@/types/reports'
import { getToken, HEADER_PREFIX } from '@/utils/auth'
import { getSentryHeaders } from '@/utils/sentry'

import { getFormattedQueryParams } from './loadReports'

const REPORTS_EXPORT_URL = `${ApiBase}/reports`

export async function exportReportsAsCSV(
  query: ReportQueryProps = {},
  signal?: AbortSignal
): Promise<void> {
  const formattedQuery = getFormattedQueryParams(query)
  const url =
    formattedQuery !== ''
      ? `${REPORTS_EXPORT_URL}?${formattedQuery}`
      : REPORTS_EXPORT_URL

  const response = await axios.post<Blob>(url, undefined, {
    responseType: 'blob',
    signal,
    headers: {
      Authorization: `${HEADER_PREFIX} ${await getToken()}`,
      ...getSentryHeaders(),
    },
  })

  const contentDisposition = response.headers['content-disposition']
  const filename = contentDisposition
    ? (contentDisposition.split('filename=')[1]?.replace(/"/g, '') ??
      'export.csv')
    : 'export.csv'

  const urlObject = window.URL.createObjectURL(response.data)

  // Create a link element
  const link = document.createElement('a')
  link.href = urlObject
  link.download = filename

  // Append to DOM and trigger click
  document.body.appendChild(link)
  link.click()

  // Clean up
  link.remove()
  window.URL.revokeObjectURL(urlObject)
}
